import { TablePagination } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import ButtonBase from '@material-ui/core/ButtonBase'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import Drawer from '@material-ui/core/Drawer'
import Skeleton from '@material-ui/lab/Skeleton'
import times from 'lodash/times'
import { pluralEntries } from './options'
import { useEffect, useRef, useState } from 'react'
import { SweepstakesOptionsContext } from './context'
import { SweepstakesHistoryOpen } from './context'
import { SweepstakesDetailsAvatar } from './Details'
import { useFindSweepstakeWinnersQuery } from '@coin-microservices/sweepstakes-react-hooks'
import { useScrollContext } from '../Scroll'

export const SweepstakesHistoryFab = ({ style }: { style?: any }) => {
  const [open, setOpen] = SweepstakesHistoryOpen.useContext()
  return (
    <ButtonBase
      onClick={() => setOpen(!open)}
      style={{
        transform: 'rotateZ(-90deg) translateX(50%)',
        transformOrigin: 'right bottom',
        backgroundColor: '#fff',
        color: '#333',
        border: '2px solid #eee',
        borderRadius: '4px 4px 0 0',
        padding: '0 6px',
        zIndex: 2000,
        transition: open
          ? 'visibility 0s linear 0s'
          : 'visibility 0s linear 0.2s',
        visibility: open ? 'hidden' : 'visible',
        ...style,
      }}
    >
      Previous Winners
    </ButtonBase>
  )
}

export const SweepstakesHistoryDrawer = () => {
  const perPage = 10
  const [page, setPage] = useState(1)
  const [open, setOpen] = SweepstakesHistoryOpen.useContext()
  const scrollElement = useScrollContext() as any
  const { data, loading } = useFindSweepstakeWinnersQuery({
    variables: {
      sort: {
        field: 'created',
        order: -1,
      },
      pagination: {
        page,
        perPage,
      },
    },
  })
  const items = data?.findSweepstakeWinners?.data
  const total = data?.findSweepstakeWinners?.total ?? 0
  useDrawerScroller(open)
  const changePage = (p: number) => {
    if (scrollElement) {
      scrollElement.scrollTop = 0
    }
    setPage(p)
  }
  const handleChangePage = (event: any, newPage: number) => {
    changePage(newPage + 1)
  }
  const rowCount = loading ? 10 : items?.length || 0
  return (
    <>
      <Drawer
        open={open}
        anchor="right"
        onClose={() => setOpen(false)}
        classes={{ paper: 'overflow-initial' }}
      >
        <div
          style={{
            maxWidth: 500,
            width: '92vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <SweepstakesHistoryFab
            style={{
              position: 'absolute',
              transform: 'rotateZ(-90deg) translate3d(50%, -120px, 0)',
              visibility: 'visible',
              top: '50%',
              left: 0,
            }}
          />
          <Box style={{ overflow: 'auto', flexGrow: 1 }}>
            <List>
              {times(rowCount).map((_, i) => (
                <SweepstakesOptionsContext.Provider
                  key={i}
                  value={items?.[i]?.options ?? null}
                >
                  <SweepstakesWinnerItem item={items?.[i]} loading={loading} />
                </SweepstakesOptionsContext.Provider>
              ))}
            </List>
          </Box>
          <Divider />
          <CardActions>
            <Box flexGrow={1} />
            <TablePagination
              count={total}
              page={page - 1}
              onChangePage={handleChangePage}
              rowsPerPage={perPage}
              rowsPerPageOptions={[perPage]}
              size="small"
            />
          </CardActions>
        </div>
      </Drawer>
    </>
  )
}

const SweepstakesWinnerItem = ({
  item,
  loading,
}: {
  item: any
  loading: boolean
}) => {
  return (
    <ListItem>
      <ListItemAvatar>
        <Box>
          {loading ? (
            <Skeleton variant="circle" height={48} width={48} />
          ) : (
            <Avatar
              variant="square"
              src={item?.profileImage ?? ''}
              alt={`${item?.username ?? ''}`}
              imgProps={{ style: { objectFit: 'contain' } }}
              style={{ height: 48, width: 48 }}
            >
              {(item?.username ?? '').slice(0, 2).toUpperCase()}
            </Avatar>
          )}
        </Box>
      </ListItemAvatar>
      <ListItemText
        primary={loading ? <Skeleton width={180} /> : item?.username}
        secondary={
          <>
            <Typography>
              {loading ? (
                <Skeleton width={160} />
              ) : item?.created ? (
                new Date(item?.created).toLocaleString()
              ) : (
                ''
              )}
            </Typography>
            <Typography>
              {loading ? (
                <Skeleton width={160} />
              ) : (
                <>
                  {item?.entries} {pluralEntries(item?.entries)}
                </>
              )}
            </Typography>
          </>
        }
      />
      <SweepstakesDetailsAvatar size={48} loading={loading} />
    </ListItem>
  )
}

function useDrawerScroller(open: boolean) {
  const scrollPosition = useRef(0)
  useEffect(() => {
    const root = document.getElementById('root')
    if (open) {
      scrollPosition.current = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.height = '100vh'
      document.body.style.width = '100vw'
      document.body.style.overflow = 'hidden'
      if (root) {
        root.style.height = '100vh'
        root.style.overflow = 'auto'
        root.scrollTop = scrollPosition.current
      }
    } else {
      document.body.style.height = 'initial'
      document.body.style.overflow = 'initial'
      document.body.style.position = 'initial'
      if (root) {
        root.style.height = 'initial'
        root.style.overflow = 'initial'
        root.scrollTop = 0
      }
      window.scrollTo(0, scrollPosition.current)
    }
  }, [open])
}
